import actions from "./actions";

const initState = {
  listContent: [],
  isLoading: false,
  currentContent: {},
};

export default function ContentReducer(state = initState, action) {
  switch (action.type) {
    case actions.SET_LIST_CONTENT:
      return {
        ...state,
        listContent: action.payload,
        isLoading: false,
      };
    case actions.SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case actions.SET_CURRENT_CONTENT:
      return {
        ...state,
        currentContent: action.payload,
      };
    default:
      return state;
  }
}
